import type { Order } from "../lib/api";
import { purchaseStatusLabel } from "../lib/purchaseStatus";
import { JourneyProgress } from "./ContractJourney";
import { useI18n } from "../lib/i18n";

export function PurchaseJourney({ order }: { order: Pick<Order, "status" | "role"> }) {
  const { t } = useI18n();
  const isBuyer = order.role === "buyer";
  const steps = [
    { label: "Payment secured", detail: "Payment held until the purchase is settled." },
    { label: "Purchase completed", detail: order.status === "completed" ? "All agreed payments have been released to the seller." : isBuyer ? "Receive and check the item, then release payment in Milestones." : "Hand over the item. The buyer confirms receipt to complete the purchase." },
  ];
  // [items.purchase-workspace](../../../docs/product/items.md#items-purchase-workspace): only order status advances this card; refund/dispute outcomes never imply normal completion.
  const current = order.status === "paid" || order.status === "fulfilled" ? 1 : order.status === "completed" ? steps.length : -1;
  // [items.cancellation-and-disputes](../../../docs/product/items.md#items-cancellation-and-disputes): earlier milestone payouts remain settled; only held funds are refunded.
  const notice = order.status === "disputed" ? "The purchase process is paused. Payment remains held while the dispute is reviewed."
    : order.status === "cancelled" ? "This purchase was cancelled. The buyer was refunded; remaining steps no longer apply."
    : order.status === "refunded" ? "The remaining held payment was refunded to the buyer; remaining steps no longer apply."
    : order.status === "resolved" ? "The dispute ended with payment split between buyer and seller; remaining steps no longer apply."
    : undefined;
  return <JourneyProgress title="Purchase process" steps={steps} current={current}
    outcome={current === -1 || current === steps.length ? purchaseStatusLabel(order.status, t) : undefined} notice={notice} />;
}
